import { render } from "./AcompanharPedido.vue?vue&type=template&id=5a9f8742&scoped=true"
import script from "./AcompanharPedido.vue?vue&type=script&lang=js"
export * from "./AcompanharPedido.vue?vue&type=script&lang=js"

import "./AcompanharPedido.vue?vue&type=style&index=0&id=5a9f8742&lang=scss"
import "./AcompanharPedido.vue?vue&type=style&index=1&id=5a9f8742&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9f8742"]])

export default __exports__